import { useQuery, useQueryClient } from 'react-query';

import { fetchLatestForUser } from '../../models/timeclock/entry/entry';

export const useTimeClockPage = (
  /**@type { import('../../models/user/_types').User }**/ user
) => {
  const queryClient = useQueryClient();

  const onClose = () => {
    queryClient.invalidateQueries('entries');
  };

  const { data: logEntry, isLoading: logEntryLoading } = useQuery({
    queryKey: ['entries', user],

    queryFn: () => {
      return fetchLatestForUser(user);
    },
  });

  return {
    onClose,
    logEntry,
    logEntryLoading,
  };
};
